"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefetchOnFocus = exports.useDataChangedEvent = exports.emitDataChanged = void 0;
/**
 * 資料異動事件（docs/介面優化.md R28）：共用的發送／訂閱，各系統的 utils/dataEvents.ts 再包一層
 * - 系統層 notifyDataChanged(topic)：先刷新自己的儀表板等 store，再呼叫 emitDataChanged(topic)
 * - 訂閱者（列表搜尋結果、詳情頁、看板）用 useDataChangedEvent 重新載入
 * 每個系統是獨立的網頁，事件名稱不用加系統前綴
 */
const react_1 = require("react");
const eventName = (topic) => `redpanda:data-changed:${topic}`;
const emitDataChanged = (topic) => {
    window.dispatchEvent(new Event(eventName(topic)));
};
exports.emitDataChanged = emitDataChanged;
/** 訂閱一個或多個主題；handler 不需要 memo（內部用 ref 保存最新版本） */
const useDataChangedEvent = (topic, handler) => {
    const handlerRef = (0, react_1.useRef)(handler);
    handlerRef.current = handler;
    const key = typeof topic === 'string' ? topic : topic.join(',');
    (0, react_1.useEffect)(() => {
        const listener = () => handlerRef.current();
        const names = key.split(',').map(eventName);
        names.forEach(name => window.addEventListener(name, listener));
        return () => names.forEach(name => window.removeEventListener(name, listener));
    }, [key]);
};
exports.useDataChangedEvent = useDataChangedEvent;
/**
 * 切回這個分頁時重抓（同 TanStack Query refetchOnWindowFocus）：在別的分頁改了資料，切回來就看得到
 * 離開不到 30 秒不重抓，避免來回切換時一直打 API
 */
const useRefetchOnFocus = (handler, minIntervalMs = 30000) => {
    const handlerRef = (0, react_1.useRef)(handler);
    handlerRef.current = handler;
    (0, react_1.useEffect)(() => {
        let hiddenAt = 0;
        const onVisibility = () => {
            if (document.hidden) {
                hiddenAt = Date.now();
            }
            else if (hiddenAt && Date.now() - hiddenAt >= minIntervalMs) {
                handlerRef.current();
            }
        };
        document.addEventListener('visibilitychange', onVisibility);
        return () => document.removeEventListener('visibilitychange', onVisibility);
    }, [minIntervalMs]);
};
exports.useRefetchOnFocus = useRefetchOnFocus;
